import { uncheckedInjectionContext as globalContext } from '@bingads-webui-campaign/injection-context';
import { DeterministicView } from '@bingads-webui/deterministic-view';
import { InputControl } from '@bingads-webui/input-control';
import { BackboneSchema as backboneSchema } from '@bingads-webui/backbone-schema';
import { Budget } from '@bingads-webui/hotel-odata-schemas';
import _ from 'underscore';
import template from './budget-bid-template.pug';
import {
  BidStrategyView,
  BidCapView,
  AccountInformationView,
} from '../hotel-center-shared';


const i18n = globalContext.require('@bingads-webui/i18n-amd-loader!campaignui/feature/hotel-center-setup');
const config = globalContext.require('component/config/index');

/**
 * View class for Hotel Ads setup wizard account budget and bit step
 * @extends Backbone.View
 */

export class BudgetBidSetupView extends DeterministicView {
  initialize({
    subAccountModel,
  }) {
    this.subAccountModel = subAccountModel;
    this.i18n = i18n;

    this.initBudgetInput();

    const accountInformationView = new AccountInformationView().setState({
      account: { Name: '' },
      subAccount: { Name: '' },
    });

    this.setChild('account-information-view-container', accountInformationView);

    const bidCapView = new BidCapView();

    this.setChild('bid-cap-view', bidCapView);
    this.listenTo(bidCapView, 'input-changed', () => {
      this.updateValidationState();
    });

    const bidStrategyView = new BidStrategyView({
      allowEmptyStrategy: false,
      isReadonly: false,
      enablePPS: true,
    });

    this.setChild('bid-strategy-view', bidStrategyView);
    this.listenTo(bidStrategyView, 'input-changed', () => {
      this.updateValidationState();
    });
  }

  get events() {
    return {
      'click input.btn.finish': 'onFinish',
      'click input.btn.return': () => {
        this.trigger('returned');
      },
      'click input.btn.cancel': () => {
        this.trigger('cancelled');
      },
    };
  }

  get template() {
    return template;
  }

  setState(state) {
    const accountInformationView = this.getChild('account-information-view-container');

    if (_.has(state, 'account')) {
      this.model.set('account', state.account);
    }

    if (_.has(state, 'name')) {
      this.model.set('name', state.name);
    }

    if (_.has(state, 'account') && _.has(state, 'name')) {
      accountInformationView.setState({
        account: { Name: state.account },
        subAccount: { Name: state.name },
      });
    }
  }

  isValid() {
    return this.getChild('budget-input').getState().isValid &&
      this.getChild('bid-cap-view').getState().isValid &&
      this.getChild('bid-strategy-view').getState().isValid;
  }

  onFinish() {
    if (!this.isValid()) {
      return;
    }

    this.subAccountModel.set('DailyBudget', this.budgetModel.toJSON());
    this.subAccountModel.set(
      'MaximumBid',
      this.getChild('bid-cap-view').getState().maximumBid
    );
    this.subAccountModel.set(
      'Bid',
      this.getChild('bid-strategy-view').getState().bid
    );

    this.trigger('finished');
  }

  initBudgetInput() {
    const BudgetModel = backboneSchema(Budget, i18n, ['Amount']);

    this.budgetModel = new BudgetModel();
    const budgetInput = new InputControl({
      entity: this.budgetModel,
      field: 'Amount',
      addonText: config.get('AccountCurrencyCode'),
    });

    this.setChild('budget-input', budgetInput);

    this.listenTo(budgetInput, 'input-changed', () => {
      this.updateValidationState();
    });
  }

  updateValidationState() {
    if (this.getChild('budget-input').getState().isValid &&
      this.getChild('bid-cap-view').getState().isValid &&
      this.getChild('bid-strategy-view').getState().isValid) {
      this.$('.finish').removeClass('disabled');
    } else {
      this.$('.finish').addClass('disabled');
    }
  }
}
